// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E1YP","colBig":"styles_colBig__2JSMv","colSmall":"styles_colSmall__11WRL"};